import React, { FC } from 'react';
import {
  BreadcrumbTree,
  DynamicComponent,
  Errors,
  HeaderText,
} from '@/components';
import { TypeAccountPage } from '@/core/generated-types';
import { HeaderSize } from '@/components/ui/HeaderText';
import { findApplicableErrorDetails } from '@/components/common/Errors/utils';

export type ReadingSkillSetPageLayoutProps = {
  page: TypeAccountPage;
  error?: string | undefined;
};

const ReadingSkillSetPageLayout: FC<ReadingSkillSetPageLayoutProps> = ({
  page,
  error,
}) => {
  const {
    fields: { title, breadcrumbTree, components, errorDirectives },
  } = page;

  const { heading, errors } = findApplicableErrorDetails(errorDirectives);
  const errorsWithServerErrorMessage = error ? errors.concat([error]) : errors;

  return (
    <div className="overflow-hidden">
      {breadcrumbTree && (
        <BreadcrumbTree
          {...breadcrumbTree.fields}
          classes="hidden md:flex mt-10 px-6 md:container mx-auto"
        />
      )}
      <HeaderText
        text={title}
        align="left"
        size={HeaderSize.H1}
        classes="mt-6 px-6 md:container mx-auto"
      />
      {error ? (
        <Errors
          heading={heading}
          errors={errorsWithServerErrorMessage}
          classes="mt-6 px-6 md:container mx-auto"
        />
      ) : (
        <section>
          {components &&
            components.map((component) => (
              <DynamicComponent key={component.sys.id} component={component} />
            ))}
        </section>
      )}
    </div>
  );
};

export default React.memo(ReadingSkillSetPageLayout);
